import { Component, inject, input } from '@angular/core';

import { News } from '@mitsubishi/news/data-access';
import { DialogService } from '@mitsubishi/ui/dialog';

import { NewsDetailDialogComponent, NewsDialogData } from '../news-detail-dialog/news-detail-dialog.component';

@Component({
  selector: 'apm-news-detail-card',
  templateUrl: './news-detail-card.component.html',
  styleUrls: ['./news-detail-card.component.scss'],
  standalone: false,
})
export class NewsDetailCardComponent {
  #dialogService = inject(DialogService);
  news = input.required<News>();

  onCardClick(): void {
    const dialogData: NewsDialogData = {
      newsId: this.news().id,
    };
    this.#dialogService.openDialog(NewsDetailDialogComponent, 'lg', dialogData);
  }
}
